// The generated documents (SPEC-v2 section 5; API.md 7.9, endpoints 85-86;
// ARCHITECTURE 17). All use the ToR's DocSection model, so one web component
// renders them all.
import { z } from "zod";
import { ATTENDANCE_MODES, GENERATED_DOCUMENT_KINDS, type GeneratedDocumentKind } from "../enums";
import { isoMonth, uuid } from "./common";
import type { DocSection } from "./tors";

/** 85. GET /api/documents/:kind/:id. An unknown kind or a malformed id answers 404. */
export const documentParams = z.object({ kind: z.enum(GENERATED_DOCUMENT_KINDS), id: uuid });
export type DocumentParams = z.infer<typeof documentParams>;

/** Query of 85: `month` is required for a timesheet (checked in the API); `mode` only for attendance. */
export const documentQuery = z
  .object({
    month: isoMonth.optional(),
    mode: z.enum(ATTENDANCE_MODES).default("attended"),
  })
  .strict();
export type DocumentQuery = z.infer<typeof documentQuery>;

export type GeneratedDocument = {
  kind: GeneratedDocumentKind;
  orgName: string;
  /** e.g. "Timesheet: Maria Rossi, November 2026" */
  title: string;
  meta: string;
  /** "Draft, not final" for draft reports; else null */
  notice: string | null;
  /** same DocSection as the ToR; keys per ARCHITECTURE 17 */
  sections: DocSection[];
  /** timesheet: ["Expert", "Contract lead"]; others [] */
  signatureLines: string[];
  footer: string;
  generatedAt: string;
};

export const DRAFT_NOTICE = "Draft, not final";
